import React from 'react';
import PropTypes from 'prop-types';

const Search01 = ({color = 'currentColor', ...props}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.1058 12.2L15.0001 15M14.0668 7.53333C14.0668 11.1416 11.1417 14.0667 7.53342 14.0667C3.92516 14.0667 1.00009 11.1416 1.00009 7.53333C1.00009 3.92507 3.92516 1 7.53342 1C11.1417 1 14.0668 3.92507 14.0668 7.53333Z"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
    />
  </svg>
);

Search01.propTypes = {
  color: PropTypes.string,
};

export default Search01;
